import React from 'react';
import { Box, Icon } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

export interface PDFIconProps {
  className?: string;
}

export const PDFIcon: React.FC<PDFIconProps> = React.memo(({ className }) => {
  return (
    <Icon
      className={className}
      component={() => (
        <img
          src={`${process.env.PUBLIC_URL}/images/home-file-pdf.svg`}
          alt="PDF"
        />
      )}
    />
  );
});

export interface UploadedIconProps {
  className?: string;
}
export const UploadedIcon: React.FC<UploadedIconProps> = ({
  className = '',
}) => {
  const StyledBox = styled(Box)({
    width: '44px',
    height: '44px',
    backgroundColor: '#EDEFF3',
    border: '1px solid #C2CAD8',
    borderRadius: '2px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& svg': {
      width: '44px',
      height: '44px',
      color: '#C2CAD8',
    },
  });

  const imgSrc = `${process.env.PUBLIC_URL}/images/visitor.svg`;
  const imgAlt = 'file uploaded';

  return (
    <StyledBox className={className}>
      <img src={imgSrc} alt={imgAlt} />
    </StyledBox>
  );
};
